import { SxProps, Theme } from '@mui/material';

export const mainContentStyles: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  flexGrow: 1,
  minHeight: 0,
  transition: 'padding-bottom 0.3s ease',
  '& > div': {
    flex: 1,
  },
  '@media screen and (max-width: 1250px)': {
    height: 'auto',
  },
};
